import { ReactNode, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { TscNetHeader } from "../TscNetHeader/TscNetHeader";
import { CustomFooter } from "../CustomFooter/CustomFooter";
import { logoutUser } from "../../services/userService";
import { logout } from "../../actions/authentificationActions";
import { getInactivitySettings } from "../../services/settingsService";

export interface LayoutProps {
    children: ReactNode;
}

export const Layout = (props: LayoutProps) => {
    const dispatch = useDispatch();
    const [activityLimitMinutes, setActivityLimitMinutes] = useState<number>();
    const [lastActivity, setLastActivity] = useState(new Date());

    const fetchInactivityLimit = useCallback(async () => {
        try {
            const res = await getInactivitySettings();
            setActivityLimitMinutes(res.inactivityTimeout);
        } catch {
            // Default value as a fallback
            setActivityLimitMinutes(10);
        }
    }, [setActivityLimitMinutes]);

    const updateActivity = useCallback(() => {
        setLastActivity(new Date());
    }, [setLastActivity]);

    useEffect(() => {
        fetchInactivityLimit();
    }, [fetchInactivityLimit]);

    const handleLogout = useCallback(async () => {
        await logoutUser();
        dispatch(logout());
    }, [dispatch]);

    useEffect(() => {
        const intervalId = setInterval(async () => {
            // Check if user is inactive and logout if so
            const now = new Date();
            const diff = (now.getTime() - lastActivity.getTime()) / 1000 / 60;
            if (activityLimitMinutes !== undefined && diff > activityLimitMinutes) {
                handleLogout();
            }
        }, 20000);

        return () => {
            clearInterval(intervalId);
        };
    });

    return (
        <>
            <TscNetHeader />
            <main id="main-layout" onMouseDownCapture={updateActivity}>{props.children}</main>
            <CustomFooter />
        </>
    );
};
